/** True when workspace bot_type is Outbound SMS (Try It Out uses OutboundSmsTryItOutPanel, not TestView). */
export default function isOutboundSmsBotType(botType) {
  const t = String(botType ?? "")
    .trim()
    .toUpperCase()
    .replace(/-/g, "_");
  return t === "OUTBOUNDSMS" || t === "OUTBOUND_SMS";
}
